import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useHistory, useLocation } from 'react-router-dom';
import { IonContent, IonPage, IonSpinner, IonText, IonButton } from '@ionic/react';

const Callback: React.FC = () => {
  const { handleRedirectCallback, isAuthenticated, isLoading, error } = useAuth0();
  const history = useHistory();
  const location = useLocation();
  const [callbackError, setCallbackError] = useState<string | null>(null);

  useEffect(() => {
    const processCallback = async () => {
      // Verifica se estamos realmente em um callback (tem code e state na URL)
      const urlParams = new URLSearchParams(location.search);
      const hasCode = urlParams.has('code');
      const hasState = urlParams.has('state');
      
      if (!hasCode || !hasState) {
        console.log('Não é um callback válido, redirecionando para home');
        history.replace('/home');
        return;
      }

      try {
        console.log('Processando callback da autenticação...');
        await handleRedirectCallback();
        console.log('Callback processado com sucesso');
        // Após o processamento bem-sucedido, redireciona para home
        history.replace('/home');
      } catch (error: any) {
        console.error('Erro no callback de autenticação:', error);
        setCallbackError(error.message || 'Erro desconhecido');
        
        // Aguarda um pouco antes de redirecionar
        setTimeout(() => {
          history.replace('/login');
        }, 3000);
      }
    };

    // Se já estiver autenticado, vai direto para home
    if (isAuthenticated) {
      console.log('Usuário já autenticado, redirecionando para home');
      history.replace('/home');
      return;
    }

    // Se ainda está carregando, aguarda
    if (isLoading) {
      return;
    }

    // Se há erro do Auth0, trata
    if (error) {
      console.error('Erro do Auth0:', error);
      setCallbackError(error.message);
      setTimeout(() => {
        history.replace('/login');
      }, 3000);
      return;
    }

    // Processa o callback
    processCallback();
  }, [handleRedirectCallback, isAuthenticated, isLoading, history, location.search, error]);

  return (
    <IonPage>
      <IonContent className="ion-padding" fullscreen>
        <div style={{ 
          display: 'flex', 
          minHeight: '100vh', 
          alignItems: 'center', 
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '20px'
        }}>
          {callbackError ? (
            <>
              <IonText color="danger" style={{ textAlign: 'center' }}>
                <h2>Erro na Autenticação</h2>
                <p>{callbackError}</p>
                <p style={{ fontSize: '0.9em', color: '#666' }}>
                  Redirecionando para o login em alguns segundos...
                </p>
              </IonText>
              <IonButton 
                color="primary" 
                onClick={() => history.replace('/login')}
              >
                Voltar ao Login
              </IonButton>
            </>
          ) : (
            <>
              <IonSpinner name="circular" style={{ transform: 'scale(2)' }} />
              <IonText color="medium" style={{ textAlign: 'center' }}>
                <p>Processando autenticação...</p>
                <p style={{ fontSize: '0.8em' }}>
                  Aguarde enquanto validamos suas credenciais
                </p>
              </IonText>
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Callback;
